// 📄 pages/Proyectos/components/horasStyles.ts
// Estilos compartidos para los estados de un registro de horas.
import { EstadoFacturacion, EstadoAprobacion } from '../../../services/registroHorasService.ts';

export const ESTADO_FACTURACION_STYLES: Record<EstadoFacturacion, string> = {
  'Pendiente': 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
  'Facturado': 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30'
};

export const ESTADO_APROBACION_STYLES: Record<EstadoAprobacion, string> = {
  'Pendiente': 'bg-white/5 text-gray-400 border-white/10',
  'Aceptado': 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  'Objetado': 'bg-red-500/10 text-red-400 border-red-500/30'
};
